import React, {useEffect} from "react";
import { SectionWrapper } from '../../../hoc';
import TableOfContents from '../../TableOfContents/TableOfContents.tsx'
import TocMobile from "../../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import './NotebookKids.css'
// import the separated file related to the component
import TextNotebookKids from './TextNotebookKids'
// import the image you want for the top of the page
import Lab from '../../../assets/laboratory.jpg'

const NotebookKids = () => {
    // headingData is used in the TableOfContents
    // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
    // the level 2 is the most important level you can have (the basic one)
      level: 2,
    // the text will be displayed in the table of contents
      text: "Problem",
    // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
    // do not use space for the id
      id: "Problem",
    },
    {
      level: 2,
      text: "Current solutions",
      id: "Current-solutions",
    },
    {
      level: 2,
      text: "Our solution",
      id: 'Our-solution',
    },
    {
    // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "A probiotic that effectively targets and reduces cadmium absorption in the human gut",
      id: 'Solution',
    },
    {
      level: 2,
      text: "Mucus binding protein construct",
      id: "mucus",
    },
    {
      level: 2,
      text: "Cadmium binding construct",
      id: "cadmium-binding",
    },

    {
      level: 2,
      text: "Additional health precautions",
      id: "health",
    },
    {
      level: 2,
      text: "References",
      id: "references"
    }
  ];
// when the page is loaded from the navbar, it sets the position of the user at the top of the page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
    {/* Display the content of the page on the entire viewport */}
    <div className="full-viewport">
        {/* Set the size and crop the image on top of the page */}
      <div className="image-container">
        {/* image of your choice will be displayed. Don't forget to change the alt name so it fits with the image */}
        <img src={Lab} className='image' alt="Lab"/>
        {/* Big title in white that is positioned on the image (no need to change the position, it is already set) */}
        <h1>NoteBook Kids</h1>
      </div>
      {/* divide the section in columns */}
      <div className="grid grid-cols-12 gap-4" style={{ marginRight: '50px', marginLeft: '50px' }}>
        {/* section on the left (=Table of content) */}
        <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
            {/* it will stay visible on the viewport */}
          <div className="sticky top-4">
            {/* call the Table of contents with headingData modified above */}
            <TableOfContents headings={headingsData} />
          </div>
        </div>
        {/* main content which is a separated file you call and it is displayed on the right of the section above */}
        <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
          <TextNotebookKids />
        </main>
        {/* display the table of content when the viewport is too small */}
        <div className="md:hidden col-span-12 order-3">
          <TocMobile headings={headingsData}/>
        </div>
      </div>
    </div>
  </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(NotebookKids, 'notebook kids')
